var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK, Button, DynamicSvg, Typography, getTestId, isLastItem, isValidObject, useBreakpoint } from '@airtel/air-design-system';
import { ImageBackground, Pressable, View } from 'react-native';
import { getImageBannerStyles } from './ImageBannerWidgetStyles';
export var ImageBannerWidgetComponent = props => {
  var id = props.id,
    onUserAction = props.onUserAction,
    style = props.style,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'light' : _props$theme,
    imageUrl = props.imageUrl,
    onPressBanner = props.onPressBanner,
    _props$resizeMode = props.resizeMode,
    resizeMode = _props$resizeMode === void 0 ? 'cover' : _props$resizeMode,
    title = props.title,
    titleColor = props.titleColor,
    subtitleColor = props.subtitleColor,
    subtitle = props.subtitle,
    primaryCta = props.primaryCta,
    secondaryCta = props.secondaryCta,
    onPrimaryCtaPress = props.onPrimaryCtaPress,
    onsecondaryCtaPress = props.onsecondaryCtaPress,
    infoList = props.infoList,
    imageAccessibilityProps = props.imageAccessibilityProps,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'ImageBannerWidget' : _props$testID,
    aspectRatio = props.aspectRatio,
    restProps = __rest(props, ["id", "onUserAction", "style", "theme", "imageUrl", "onPressBanner", "resizeMode", "title", "titleColor", "subtitleColor", "subtitle", "primaryCta", "secondaryCta", "onPrimaryCtaPress", "onsecondaryCtaPress", "infoList", "imageAccessibilityProps", "testID", "aspectRatio"]);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var imageBannerStyles = getImageBannerStyles(props, isLargeScreen);
  var Wrapper = isValidObject(onPressBanner) ? Pressable : View;
  return _jsx(Wrapper, Object.assign({
    onPress: () => {
      onPressBanner && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onPressBanner), {
        props
      }));
    }
  }, {
    children: _jsx(ImageBackground, Object.assign({
      imageStyle: {
        resizeMode,
        aspectRatio
      },
      source: {
        uri: isLargeScreen ? imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.desktop : imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.mobile
      },
      style: [imageBannerStyles.imageBannerBackground, style]
    }, imageAccessibilityProps, getTestId(testID, 'imageUrl'), restProps, {
      children: _jsxs(View, Object.assign({
        style: imageBannerStyles.container
      }, {
        children: [!!title && _jsx(Typography, Object.assign({
          text: title,
          type: isLargeScreen ? 'h6-bold' : 'body-para-xl-bold',
          theme: theme,
          style: imageBannerStyles.imageBannerTitle,
          color: titleColor
        }, getTestId(testID, 'title'))), !!subtitle && _jsx(Typography, Object.assign({
          text: subtitle,
          type: isLargeScreen ? 'h6-bold' : 'body-para-xl-bold',
          theme: theme,
          style: imageBannerStyles.imageBannerSubtitle,
          color: subtitleColor
        }, getTestId(testID, 'subtitle'))), !!(infoList === null || infoList === void 0 ? void 0 : infoList.length) && _jsx(View, Object.assign({
          style: imageBannerStyles.imageBannerinfoContainer
        }, {
          children: infoList === null || infoList === void 0 ? void 0 : infoList.map((item, index) => {
            return _jsxs(View, Object.assign({
              style: [imageBannerStyles.imageBannerinfoItem, !isLastItem(infoList, index) && imageBannerStyles.imageBannerinfoItemGap]
            }, getTestId(testID, "info_list_" + index), {
              children: [!!(item === null || item === void 0 ? void 0 : item.icon) && _jsx(DynamicSvg, {
                iconName: item === null || item === void 0 ? void 0 : item.icon,
                style: imageBannerStyles.imageBannerMarginRight,
                color: BLACK,
                fontSize: 14
              }), (item === null || item === void 0 ? void 0 : item.text) && _jsx(Typography, {
                text: item.text,
                type: "body-single-line-xs",
                color: (item === null || item === void 0 ? void 0 : item.textColor) || BLACK,
                theme: theme
              })]
            }), "info_" + index);
          })
        })), (!!(primaryCta === null || primaryCta === void 0 ? void 0 : primaryCta.title) || !!(secondaryCta === null || secondaryCta === void 0 ? void 0 : secondaryCta.title)) && _jsxs(View, Object.assign({
          style: imageBannerStyles.imageBannerButtonContainer
        }, {
          children: [!!(primaryCta === null || primaryCta === void 0 ? void 0 : primaryCta.title) && _jsx(Button, Object.assign({
            style: imageBannerStyles.imageBannerMarginRight,
            size: "sm",
            buttonType: primaryCta.buttonType || 'primary',
            theme: theme,
            title: primaryCta.title
          }, getTestId(testID, 'primarycta'), {
            onPress: () => onPrimaryCtaPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onPrimaryCtaPress), {
              title: primaryCta.title
            }))
          })), !!(secondaryCta === null || secondaryCta === void 0 ? void 0 : secondaryCta.title) && _jsx(Button, Object.assign({
            size: "sm",
            buttonType: secondaryCta.buttonType || 'tertiary',
            theme: theme,
            title: secondaryCta.title
          }, getTestId(testID, 'secondarycta'), {
            onPress: () => onsecondaryCtaPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onsecondaryCtaPress), {
              title: secondaryCta.title
            }))
          }))]
        }))]
      }))
    }))
  }));
};
ImageBannerWidgetComponent.genericRendererKey = 'AirImageBannerWidget';